import { useEffect } from 'react'

export function useScrollToSection(loading: boolean, id: string) {
  useEffect(() => {
    const selector = document.querySelector(`#${id}`)
    if (selector && !loading) {
      selector?.scrollIntoView({ behavior: 'smooth' })
    }
  }, [loading])
}
